$('body').on('click', '.displayRecipientInfo', function (event) {
  event.preventDefault();
  event.stopPropagation();
  $(this).siblings('.quickView').addClass('show');
  $(this).hide();
});
